import {
    IconDelete,
    IconEdit,
    Numbox,
    ScrollbarSvg
} from '@adserve/adserve-react-components';
import React, { useEffect, useRef, useState } from 'react';

export const Header = ({ area, style, scrollPx = 0, ...props }) => (
    <div
        id={area}
        {...props}
        style={{
            display: 'flex',
            gridArea: area,
            border: '1px solid #d7d7d7',
            boxSizing: 'border-box',
            alignItems: 'center',
            justifyContent: 'space-around',
            position: 'relative',
            borderWidth: '1px 1px 1px 0',
            zIndex: 1,
            height: 30,
            color: '#414141',
            fontFamily: 'roboto',
            fontSize: 15,
            fontWeight: 500,
            backgroundColor: '#ffffff',
            boxShadow:
                scrollPx > 0
                    ? '3px 2px 6px 0 rgba(139,104,70,0.33)'
                    : undefined,
            ...style
        }}
    />
);

export const ActionHeader = ({ style, ...props }) => (
    <Header
        {...props}
        style={{
            fontSize: 9,
            borderWidth: 1,
            ...style
        }}
    />
);

export const GutterCap = ({ area = 'gutterH', style, ...props }) => (
    <Header
        {...props}
        area={area}
        scrollPx={0}
        style={{ borderWidth: '1px 1px 1px 0', ...style }}
    />
);

export const Cell = ({
    area,
    style,
    scrollPx,
    isHighlighted = false,
    index,
    rowHeight,
    midPosition = 0,
    visibleRows,
    draggable = false,
    ...props
}) => {
    const upperVisibleBoundary = rowHeight * (index + 1);
    const lowerVisibleBoundary =
        upperVisibleBoundary - rowHeight * (visibleRows + 1);

    const isVisible =
        scrollPx > lowerVisibleBoundary && scrollPx < upperVisibleBoundary;

    return (
        <div
            {...props}
            id={area}
            draggable={draggable}
            style={{
                display: 'flex',
                gridArea: area,
                border: '1px solid #d7d7d7',
                boxSizing: 'border-box',
                alignItems: 'center',
                justifyContent: 'space-around',
                color: '#414141',
                fontFamily: 'roboto',
                height: rowHeight,
                fontSize: 15,
                fontWeight: 500,
                position: 'relative',
                borderWidth: '0 1px 1px 0',
                opacity: isVisible * 1,
                pointerEvents: isVisible ? 'auto' : 'none',
                bottom: scrollPx + midPosition,
                cursor: draggable ? 'move' : 'auto',
                backgroundColor: isHighlighted
                    ? '#DCFFFF'
                    : (index + 1) % 2
                    ? 'rgba(216,216,216,0.2)'
                    : '#ffffff',
                ...style
            }}
        />
    );
};

export const Gutter = ({
    area = 'gutter',
    scrollPx,
    onScroll,
    scrollableLength,
    maxVisibleLength,
    style,
    ...props
}) => {
    const ref = useRef(null);

    return (
        <div
            ref={ref}
            id={`scrollbar-gutter-${area}`}
            style={{
                boxSizing: 'border-box',
                backgroundColor: '#ffffff',
                border: '1px solid #d7d7d7',
                borderWidth: '0 1px 1px 0',
                gridArea: area,
                padding: 1,
                zIndex: 2,
                ...style
            }}
        >
            <ScrollbarSvg
                {...props}
                id={`scrollbar-${area}`}
                scrollPx={scrollPx}
                onScroll={onScroll}
                gutterOffset={
                    ref?.current?.offsetTop +
                        ref?.current?.offsetParent?.offsetTop || 0
                }
                maxVisibleLength={maxVisibleLength - 3}
                scrollableLength={scrollableLength - 3}
            />
        </div>
    );
};

export const InputNumberCell = ({
    value,
    inputStyle,
    onChange,
    index,
    disabled = false,
    allowFloat = false,
    isHighlighted = false,
    ...props
}) => {
    return (
        <Cell index={index} isHighlighted={isHighlighted} {...props}>
            <Numbox
                value={!disabled && value === undefined ? '' : value}
                style={{
                    height: 26,
                    boxSizing: 'unset',
                    width: '100%',
                    fontSize: 15,
                    fontFamily: 'roboto',
                    fontWeight: 500,
                    color: '#414141',
                    border: 0,
                    borderRadius: 0,
                    backgroundColor: isHighlighted
                        ? '#DCFFFF'
                        : disabled
                        ? (index + 1) % 2
                            ? 'rgba(216,216,216,0.2)'
                            : '#ffffff'
                        : (index + 1) % 2
                        ? '#fef9e3'
                        : '#fffdf4',
                    ...inputStyle
                }}
                onChange={onChange}
                allowFloat={allowFloat}
                placeholder={window.translate('Add value...')}
                disabledString={value?.toString()}
                disabled={disabled}
            />
        </Cell>
    );
};

export const LinkCell = ({ onClick, style, ...props }) => {
    return (
        <Cell
            {...props}
            style={{ color: '#1101BE', cursor: 'pointer', ...style }}
            onClick={onClick}
        />
    );
};

export const EditCell = ({ onClick, disabled = false, ...props }) => {
    return (
        <Cell {...props}>
            {!disabled && (
                <IconEdit
                    style={{
                        width: 18,
                        height: 21
                    }}
                    viewBox='0 0 50 50'
                    cursor='pointer'
                    onClick={onClick}
                />
            )}
        </Cell>
    );
};

export const DeleteCell = ({ onClick, disabled = false, ...props }) => {
    return (
        <Cell {...props}>
            {!disabled && (
                <IconDelete
                    style={{
                        width: 18,
                        height: 21
                    }}
                    viewBox='0 0 50 50'
                    cursor='pointer'
                    onClick={onClick}
                />
            )}
        </Cell>
    );
};
